import React from "react";

interface TabItem {
  label: string;
  value: string;
}

interface UserTabProps {
  tabs: TabItem[];
  activeTab: string;
}

const UserTab: React.FC<UserTabProps> = ({ tabs, activeTab }) => {
  return (
    <div className="flex border-b border-darkcolor-400 px-[32px] bg-darkcolor-700">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          className={`px-[16px] py-[12px] text-[16px] font-medium focus:outline-none transition-all
            ${activeTab === tab.value
              ? "border-b-2 border-secondary-500 text-primary-400"
              : "border-b-2 border-transparent text-neutral-25 hover:text-primary-300"}
          `}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default UserTab;
